// extracted by mini-css-extract-plugin
export var orderSummary = "_r0-0";
export var showMoreLessButton = "_r0-1";